import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import './Style/SubjectTopics.css';
import Loading from "../home/Loading";
import WebPage from "../AllData/WebPage";
import TopHeader from "../home/TopHeader";
import TopNavbar from "../home/TopNavbar";

function WebPageTopics({ subject, type }) {
    const allPage = WebPage;
    const [webPage, setwebPage] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const filteredPdfs = allPage.filter(pdf =>
                    pdf.subject === subject && pdf.type === type
                );
                setwebPage(filteredPdfs);

            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [allPage, subject, type]); // Removed webPage from dependencies to avoid infinite loop

    // Check if a URL is external (starts with http:// or https://)
    const isExternalLink = (url) => {
        return /^https?:\/\//i.test(url);
    };

    if (loading) {
        return <Loading message="Loading......." />;
    }

    return (
        <div className="subject-topics-page">
            
            <TopHeader name= {subject} />
            <TopNavbar name= {subject} />

            <div className="topics-container">
                {webPage.map((page, index) => {
                    // Determine if this is an external link
                    const external = isExternalLink(page.link);

                    return (
                        <div className={`topic-card`} key={page._id}>
                            {external ? (
                                // For external links, use a regular <a> tag
                                <a
                                    href={page.link}
                                    className="link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <div className="topic-header">
                                        <h3>
                                            {page.symbol} {page.name}
                                        </h3>
                                    </div>
                                </a>
                            ) : (
                                // For internal routes, use Link
                                <Link
                                    to={page.link}
                                    className="link"
                                >
                                    <div className="topic-header">
                                        <h3>
                                            {page.symbol} {page.name}
                                        </h3>
                                    </div>
                                </Link>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default WebPageTopics;